import React from "react";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaLinkedin,
  FaGlobe,
  FaMapMarkerAlt,
  FaTrophy,
  FaGraduationCap,
  FaCertificate,
  FaLightbulb,
} from "react-icons/fa";
import "./EnhancvTemplate.css";

const EnhancvTemplate = ({ resumeData }) => {
  if (!resumeData) return <div className="cv-loading">Loading...</div>;

  const {
    personal = {},
    education = [],
    experience = [],
    skills = { technical: [], soft: [], languages: [] },
    achievements = [],
    interests = [],
    certifications = [],
  } = resumeData;

  return (
    <div className="cv-a4-wrapper">
      {/* HEADER SECTION */}
      <header className="cv-main-header">
        <div className="cv-header-left">
          <h1 className="cv-name-title">{personal.fullName || "YOUR NAME"}</h1>
          <p className="cv-job-title">{personal.title || "Target Role"}</p>

          <div className="cv-contact-grid">
            {personal.email && (
              <span>
                <FaEnvelope /> {personal.email}
              </span>
            )}
            {personal.phone && (
              <span>
                <FaPhoneAlt /> {personal.phone}
              </span>
            )}
            {personal.linkedin && (
              <span>
                <FaLinkedin /> LinkedIn
              </span>
            )}
            {personal.address && (
              <span>
                <FaMapMarkerAlt /> {personal.address}
              </span>
            )}
          </div>
        </div>
        {/* Abstract Background Design Element */}
        <div className="cv-header-design"></div>
      </header>

      <div className="cv-body-grid">
        {/* LEFT COLUMN: Main Content */}
        <div className="cv-left-col">
          {/* SUMMARY */}
          {personal.summary && (
            <section className="cv-section">
              <h3 className="cv-section-label">SUMMARY</h3>
              <p className="cv-summary-text">{personal.summary}</p>
            </section>
          )}

          {/* EXPERIENCE */}
          {experience.length > 0 && (
            <section className="cv-section">
              <h3 className="cv-section-label">EXPERIENCE</h3>
              {experience.map((exp, idx) => (
                <div key={idx} className="cv-experience-block">
                  <div className="cv-exp-row">
                    <span className="cv-bold-text">{exp.title}</span>
                    <span className="cv-date-badge">
                      {exp.startDate} — {exp.current ? "Present" : exp.endDate}
                    </span>
                  </div>
                  <div className="cv-company-info">
                    <span className="cv-accent-text">{exp.company}</span>
                    <span className="cv-gray-text">{exp.location}</span>
                  </div>
                  <ul className="cv-bullet-points">
                    {exp.description?.split("\n").map((line, i) => (
                      <li key={i}>{line}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </section>
          )}

          {/* LANGUAGES */}
          {skills.languages?.length > 0 && (
            <section className="cv-section">
              <h3 className="cv-section-label">LANGUAGES</h3>
              <div className="cv-lang-flex">
                {skills.languages.map((lang, idx) => (
                  <div key={idx} className="cv-lang-tag">
                    <span className="cv-bold-text">{lang}</span>
                    <div className="cv-lang-bar">
                      <div className="cv-lang-fill"></div>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          )}
        </div>

        {/* RIGHT COLUMN: Sidebar Content */}
        <div className="cv-right-col">
          {/* ACHIEVEMENTS */}
          {achievements.length > 0 && (
            <section className="cv-section">
              <h3 className="cv-section-label">KEY ACHIEVEMENTS</h3>
              {achievements.map((ach, idx) => (
                <div key={idx} className="cv-sidebar-item">
                  <FaTrophy className="cv-side-icon" />
                  <div>
                    <p className="cv-bold-text cv-small">{ach.split(":")[0]}</p>
                    <p className="cv-gray-text cv-xsmall">{ach}</p>
                  </div>
                </div>
              ))}
            </section>
          )}

          {/* SKILLS */}
          {skills.technical?.length > 0 && (
            <section className="cv-section">
              <h3 className="cv-section-label">SKILLS</h3>
              <div className="cv-skills-cloud">
                {skills.technical.map((skill, idx) => (
                  <span key={idx} className="cv-skill-pill">
                    {skill}
                  </span>
                ))}
              </div>
            </section>
          )}

          {/* EDUCATION */}
          {education.length > 0 && (
            <section className="cv-section">
              <h3 className="cv-section-label">EDUCATION</h3>
              {education.map((edu, idx) => (
                <div key={idx} className="cv-sidebar-item">
                  <FaGraduationCap className="cv-side-icon" />
                  <div>
                    <p className="cv-bold-text cv-small">{edu.degree}</p>
                    <p className="cv-accent-text cv-xsmall">
                      {edu.institution}
                    </p>
                    <p className="cv-gray-text cv-xsmall">{edu.year}</p>
                  </div>
                </div>
              ))}
            </section>
          )}

          {/* TRAINING */}
          {certifications.length > 0 && (
            <section className="cv-section">
              <h3 className="cv-section-label">TRAINING</h3>
              {certifications.map((cert, idx) => (
                <div key={idx} className="cv-sidebar-item">
                  <FaCertificate className="cv-side-icon" />
                  <div>
                    <p className="cv-bold-text cv-small">{cert.name}</p>
                    <p className="cv-gray-text cv-xsmall">{cert.issuer}</p>
                  </div>
                </div>
              ))}
            </section>
          )}
        </div>
      </div>
    </div>
  );
};

export default EnhancvTemplate;
